import { create } from "zustand";
import { productService } from "../services/api";

export const useProductStore = create((set, get) => ({
  products: [],
  categories: [],
  loading: false,
  error: null,

  // Fetch products from database
  fetchProducts: async (params = {}, append = false) => {
    set({ loading: true, error: null });
    try {
      const response = await productService.getAll(params);
      set((state) => ({
        products: append ? [...state.products, ...response.data] : response.data,
        loading: false,
        error: null // Clear any previous errors
      }));
      return response.data; // Return data so caller can determine if there are more items
    } catch (error) {
      console.error("Error fetching products:", error);
      set({ error: error.message, loading: false, products: append ? get().products : [] });
      return [];
    }
  },

  // Add product to database
  addProduct: async (product) => {
    set({ loading: true, error: null });
    try {
      const response = await productService.create(product);
      set((state) => ({ products: [response.data, ...state.products], loading: false }));
      return response.data;
    } catch (error) {
      console.error("Error fetching products:", error);
      set({ error: error.message, loading: false, products: [] });
      throw error;
    }
  },

  // Update product in database
  updateProduct: async (id, updatedProduct) => {
    try {
      const response = await productService.update(id, updatedProduct);
      set((state) => ({
        products: state.products.map((p) =>
          p.id === id ? response.data : p
        ),
      }));
      return response.data;
    } catch (error) {
      console.error("Error updating product:", error);
      throw error;
    }
  },

  // Delete product from database
  deleteProduct: async (id) => {
    set({ loading: true, error: null });
    try {
      await productService.delete(id);
      set((state) => ({
        products: state.products.filter((p) => p.id !== id),
        loading: false,
      }));
    } catch (error) {
      console.error("Error deleting product:", error);
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchCategories: async () => {
    try {
        const response = await productService.getCategories();
        set({ categories: response.data });
    } catch (error) {
        console.error("Error fetching categories:", error);
    }
  },

  addCategory: async (name, name_am) => {
      try {
          const response = await productService.createCategory(name, name_am);
          set(state => ({ 
              categories: [...state.categories.filter(c => c.id !== response.data.id), response.data] 
          }));
          return response.data;
      } catch (error) {
          console.error("Error adding category:", error);
          throw error;
      }
  }
}));
